import React from "react";
import { InputContainer } from "./style";
const Input = ({
  type,
  name,
  onChange,
  value,
  label,
  icon,
  ltr,
  placeholder,
  error,
  required,
}) => {
  const modes = {
    text: "text",
    number: "numeric",
    password: "password",
    email: "email",
  };
  const filterToNumber = (value) => {
    if (value) {
      return value.replace(/\D/g, "");
    } else {
      return value;
    }
  };
  return (
    <InputContainer icon={icon} ltr={ltr} error={error} required={required}>
      <label>{label}</label>
      <div className="input-area">
        {icon}
        <input
          type={type === "number" ? "text" : type}
          inputMode={modes[type] ? modes[type] : "text"}
          name={name}
          onChange={(e) => {
            if (type === "number") {
              onChange({
                target: { name: name, value: filterToNumber(e.target.value) },
              });
            } else {
              onChange(e);
            }
          }}
          value={type === "number" ? filterToNumber(value) : value}
          placeholder={placeholder}
        />
        <span className="error">{error}</span>
      </div>
    </InputContainer>
  );
};
export default Input;
